<template>
  <div>
    <input-field v-focus v-model="account.user.password" label="Password" type="password" />
    <input-field v-model="account.user.passwordConfirmation" label="Confirm password" type="password" />

    <div class="mb-2">
      <label>Password Strength</label>
      <progress :class="{
        progress: true,
        'progress-error': 1 == passwordStrength.score,
        'progress-warning': 2 == passwordStrength.score,
        'progress-primary': 3 == passwordStrength.score,
        'progress-success': 4 == passwordStrength.score
      }" :value="passwordStrength.score" max="4"></progress>
      <span v-if="passwordStrength.feedback.warning === '' && passwordStrength.feedback.suggestions.length === 0">
        Password is strong
      </span>
      <span v-else>
        <span>{{ passwordStrength.feedback.warning }}</span>
        <span>{{ passwordStrength.feedback.suggestions.join(' ') }}</span>
      </span>
    </div>

    <div class="form-control mb-4 mt-4">
      <label class="cursor-pointer label">
        <input v-model="serviceAndPolicyAcceptedBridge" type="checkbox" class="checkbox mr-4" dusk="terms-checkbox" />
        <span class="label-text">
          I have read and agree to the
          <a class="link" :href="`https://${marketingUrl}/terms-of-service`">terms of use</a>
          and
          <a class="link" :href="`https://${marketingUrl}/privacy-policy`">privacy notice</a>.
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serviceAndPolicyAccepted: {
      type: Boolean,
      required: true
    },

    account: {
      type: Object,
      required: true
    },

    passwordStrength: {
      type: Object,
      required: true
    }
  },

  computed: {
    serviceAndPolicyAcceptedBridge: {
      get() {
        return this.serviceAndPolicyAccepted;
      },
      set(value) {
        this.$emit('update:serviceAndPolicyAccepted', value);
      }
    }
  }
};
</script>
